module.exports = __webpack_public_path__ + "img/20200417141834TIM截图20200417141222.dd6c8607.png";